module.exports = __webpack_public_path__ + "img/icon-403-color.e8f22d90.svg";